import UserAINavigatorBoxes from "./UserAINavigatorBoxes";

export default UserAINavigatorBoxes;